import { createDraftSafeSelector } from '@reduxjs/toolkit';
import sum from 'lodash/sum';

const selectSelf = (state: RootState) => state.counters;

const countersSelector = createDraftSafeSelector(selectSelf, (state) => {
  const { auctions, myAuctions } = state;
  const total = sum(Object.values(auctions));
  let myAuctionsAll = sum(Object.values({ ...myAuctions, following: 0 }));
  const myAuctionsTotal = sum(Object.values(myAuctions));

  const counters = {
    auctions: {
      ...auctions,
      total,
    },
    myAuctions: {
      ...myAuctions,
      all: myAuctionsAll,
      total: myAuctionsTotal,
    },
  };
  return counters;
});

const filteredCountersSelector = createDraftSafeSelector(selectSelf, (state) => {
  const { auctions, filteredAuctions, myAuctions, filteredMyAuctions } = state;
  const total = sum(Object.values({ ...auctions, ...filteredAuctions }));
  let myAuctionsAll = sum(Object.values({ ...myAuctions, following: 0 }));
  const myAuctionsTotal = sum(Object.values({ ...myAuctions, ...filteredMyAuctions }));

  const counters = {
    auctions: {
      ...auctions,
      ...filteredAuctions,
      total,
    },
    myAuctions: {
      ...myAuctions,
      ...filteredMyAuctions,
      all: myAuctionsAll,
      total: myAuctionsTotal,
    },
  };

  return counters;
});

export const countersSelectors = {
  countersSelector,
  filteredCountersSelector,
};
